import type { RegisterOptions } from 'react-hook-form';

import { loc } from '@/localization';
import { userPasswordPolicies } from '@/utils/userPasswordPolicies';

export type ValidationOptions = Pick<
    RegisterOptions,
    'required' | 'min' | 'max' | 'minLength' | 'maxLength' | 'pattern' | 'validate'
>;

export const email: ValidationOptions = {
    required: loc.Validation.InvalidEmailAddress,
    pattern: {
        /* eslint-disable no-control-regex */
        value: /^((([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#$%&'*+\-/=?^_`{|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
        /* eslint-enable */
        message: loc.Validation.InvalidEmailAddress,
    },
};

export const password: ValidationOptions = {
    required: loc.Validation.InvalidPassword,
    validate: {
        notEmpty: (value: string) => value.trim() !== '' || loc.Validation.InvalidPassword,
        minLength: (value: string) => value.trim().length >= 8 || loc.Validation.PasswordValueTooShort,
        maxLength: (value: string) => value.trim().length <= 20 || loc.Validation.PasswordValueTooLong,
    },
};

export const captcha: ValidationOptions = {
    required: loc.Validation.InvalidTextRequired,
    minLength: {
        value: 5,
        message: loc.Validation.InvalidTextRequired,
    },
};

export const name: ValidationOptions = {
    maxLength: {
        value: 250,
        message: '',
    },
};

export const required: ValidationOptions = {
    required: true,
};

export const loginPassword: ValidationOptions = {
    required: loc.Login.InvalidUsernameOrPassword,
    validate: (value: string) => value.trim() !== '' || loc.Login.InvalidUsernameOrPassword,
};

export const registerPassword: ValidationOptions = {
    maxLength: {
        value: 200,
        message: loc.Validation.PasswordPolicyMaxLength,
    },
    validate: userPasswordPolicies,
};
